/** Converts a base64 data URL into a Blob without using fetch. */
export function dataUrlToBlob(dataUrl) {
  var _dataUrl$split$, _dataUrl$split$2, _header$match$, _header$match;
  var header = (_dataUrl$split$ = dataUrl.split(",")[0]) !== null && _dataUrl$split$ !== void 0 ? _dataUrl$split$ : "";
  var base64 = (_dataUrl$split$2 = dataUrl.split(",")[1]) !== null && _dataUrl$split$2 !== void 0 ? _dataUrl$split$2 : "";
  var mime = (_header$match$ = (_header$match = header.match(/:(.*?);/)) === null || _header$match === void 0 ? void 0 : _header$match[1]) !== null && _header$match$ !== void 0 ? _header$match$ : "application/octet-stream";
  var binary = atob(base64);
  var bytes = new Uint8Array(binary.length);
  for (var index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return new Blob([bytes], {
    type: mime
  });
}

/** Reads a File as a base64 data URL. */
export function fileToDataUrl(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      return resolve(String(reader.result));
    };
    reader.onerror = function () {
      return reject(reader.error);
    };
    reader.readAsDataURL(file);
  });
}

/** Returns the file extension implied by a data URL's MIME type. */
export function extensionFromDataUrl(dataUrl) {
  var _dataUrl$split$0$matc, _dataUrl$split$3, _mime$split$;
  var mime = (_dataUrl$split$0$matc = (_dataUrl$split$3 = dataUrl.split(",")[0]) === null || _dataUrl$split$3 === void 0 || (_dataUrl$split$3 = _dataUrl$split$3.match(/:(.*?);/)) === null || _dataUrl$split$3 === void 0 ? void 0 : _dataUrl$split$3[1]) !== null && _dataUrl$split$0$matc !== void 0 ? _dataUrl$split$0$matc : "";
  return (_mime$split$ = mime.split("/")[1]) !== null && _mime$split$ !== void 0 ? _mime$split$ : "png";
}